var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-referral-solutions"},[(_vm.title)?_c('div',{staticClass:"plugin-referral-solutions__title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('div',{staticClass:"plugin-referral-solutions__items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }